export const SCREEN_VALUES = {
  CUSTOMERS: '1',
  USERS: '2',
  RESELLERS: '3',
};

export const DEFAULT_RESELLER_ID = 0;

export const ORGANIZATIONS_KEY = ['super-admin-organizations'];
export const SORTKEYS = {
  BUSINESS: 'BUSINESS',
};

export const SUPER_ADMIN_IMS_SINGLE = 'super-admin-ims-single';
export const SUPER_ADMIN_IMS_UNCONNECTED = 'super-admin-ims-unconnected';
export const SUPER_ADMIN_IMS_CONNECTED = 'super-admin-ims-connected';
export const SUPER_ADMIN_IMS_AVAILABILITY = 'ims-availability';
export const SUPER_ADMIN_IMS_DOWNLOAD_SOURCE_FILE = 'ims-download-source-file';
export const AUTOMOTIVE_RESELLER_ID = 37;
export const COVIDEO_RESELLER_ID = 1;
export const DEFAULT_PLAYBACK_URL_VALUE = 'vidmails.com';
export const PASSWORD_ERROR_MESSAGE =
  'Password must contain at least 8 characters, one upper case, one lower case, one number and special characters (only !@#$%^&* special characters can be used).';
export const NAPLETON_AUTOMOTIVE_RESELLER_ID = 441;

export const ADMIN_CUSTOMER_IDS = ['3', '1210'];
export const CAMPING_WORLD_RESELLER_ID = '138';
export const CAMPING_WORLD_IDS = [
  '27676',
  '72515',
  '105568',
  '113955',
  '116067',
];

export const BRAND_STATUS = {
  OK: 'OK',
  REGISTRATION_PENDING: 'REGISTRATION_PENDING',
  REGISTRATION_FAILED: 'REGISTRATION_FAILED',
  VERIFIED: 'VERIFIED',
  UNVERIFIED: 'UNVERIFIED',
};

export const CAMPAIGN_STATUS = {
  TCR_PENDING: 'TCR_PENDING',
  TCR_ACCEPTED: 'TCR_ACCEPTED',
  TCR_FAILED: 'TCR_FAILED',
  TCR_SUSPENDED: 'TCR_SUSPENDED',
  TCR_EXPIRED: 'TCR_EXPIRED',
  TELNYX_ACCEPTED: 'TELNYX_ACCEPTED',
  TELNYX_FAILED: 'TELNYX_FAILED',
  MNO_PENDING: 'MNO_PENDING',
  MNO_ACCEPTED: 'MNO_ACCEPTED',
  MNO_REJECTED: 'MNO_REJECTED',
  MNO_PROVISIONED: 'MNO_PROVISIONED',
  MNO_PROVISIONING_FAILED: 'MNO_PROVISIONING_FAILED',
};

export const ERROR_CAMPAIGN_STATUSES = [
  CAMPAIGN_STATUS.TCR_FAILED,
  CAMPAIGN_STATUS.TCR_SUSPENDED,
  CAMPAIGN_STATUS.TCR_EXPIRED,
  CAMPAIGN_STATUS.TELNYX_FAILED,
  CAMPAIGN_STATUS.MNO_REJECTED,
  CAMPAIGN_STATUS.MNO_PROVISIONING_FAILED,
];

export const PENDING_CAMPAIGN_STATUSES = [
  CAMPAIGN_STATUS.TCR_PENDING,
  CAMPAIGN_STATUS.MNO_PENDING,
];
export const DEFAULT_10DLC_COUNTRY = 'US';

export const ALLOWED_USER_IDS_FOR_SMS_SETTING = ['135459', '167184', '19416'];
